import { IApplicationState } from '../../types/redux';

export function getIsFlatViewOrderEnabled(state: IApplicationState): boolean {
  return Boolean(state.newbuilding?.flatViewOrder?.isEnabled);
}
